module.exports = __webpack_public_path__ + "img/background.5395a4df.jpg";